import React from "react";

import Background from "../../../assets/cleaning/cleaning-select.png";
import ImageA from "../../../assets/cleaning/cleaning-option-a.png";
import ImageB from "../../../assets/cleaning/cleaning-option-b.png";

import GameSelectionLayout from "../GameSelectionLayout";

const CleaningPage2 = ({ setCurrentPage, setGarbageQtty }) => {
  const handleClickA = () => {
    setCurrentPage("cleaning-3");
  };

  const handleClickB = () => {
    setGarbageQtty((prev) => prev + 5);
    setCurrentPage("cleaning-4");
  };

  return (
    <GameSelectionLayout
      bg={Background}
      imageA={ImageA}
      textA="마른걸레"
      onClickA={handleClickA}
      imageB={ImageB}
      textB="1회용청소포"
      onClickB={handleClickB}
      currentIndex={3}
    >
      아 맞다.
      <br />
      청소기 고장 났는데...
      <br />
      바닥은 어떻게 청소하지?
    </GameSelectionLayout>
  );
};

export default CleaningPage2;
